import { stringify } from 'querystring';
import { Axios, ceV2Axios } from './axios';
import {
  DataResponse,
  SingleProductOrder,
  Feature,
  PageableResponse,
  Invoice,
} from '../models';

export const getInvoices = async (invoiceRequest: Required<{ invoiceNumbers: string[] }>) => (await ceV2Axios.get<DataResponse<Invoice[]>>('/invoices', {
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
  params: {
    invoice_number: invoiceRequest.invoiceNumbers,
  },
  paramsSerializer: {
    serialize: params => stringify(params),
  },
  data: {},
})).data.data;

export const getPendingInvoices = async (invoiceRequest: Required<Pick<Invoice, 'organizationId'>> & Required<{ features: Feature[] }>) => (await ceV2Axios.get<PageableResponse<Invoice>>('/invoices/pending', {
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
  params: {
    organization_id: invoiceRequest.organizationId,
    features: invoiceRequest.features.map(it => it.toString()),
  },
  paramsSerializer: {
    serialize: params => stringify(params),
  },
  data: {},
})).data.data;

export const previewInvoice = async (data: Required<Pick<SingleProductOrder, 'organizationId' | 'planId' | 'number'>> & Partial<Pick<SingleProductOrder, 'discountCode' | 'newQuotaNumber'>>) => (await Axios.post<DataResponse<Invoice>>('/invoices/preview', data)).data.data;

export const previewRenewal = async (accountId: number) => (await Axios.post<DataResponse<Invoice[]>>(`/invoices/preview-renewal/${accountId}`, {
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
})).data.data;

export const fetchPastDueInvoice = async (accountId: number) => (await Axios.get<DataResponse<Invoice[]>>(`/invoices/past-due/${accountId}`, {
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
})).data.data;

export const retryPayment = async (accountId: number) => (await Axios.post<DataResponse<string>>(`/invoices/past-due/retry/${accountId}`, {
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
})).data.data;
